<tc-validate-email-form
  *ngIf="!identity && linkValid"
  (submitted)="validateIdentity.emit($event)"
  [pending]="pending"
  [errorMessage]="validateError"
  [value]="validateValue"
>
</tc-validate-email-form>

<div class="card-form" *ngIf="!linkValid">
  <mat-card>
    <mat-card-title
      i18n="@@validate.email.link.title"
    >
      Invitation link expired!
    </mat-card-title>
    <mat-card-content>
      <p class="mat-typography"
         i18n="@@validate.email.link.error"
      >
        Unfortunately, your invite link has expired, please contact the person who invited you to receive a new one.
      </p>
      <p class="mat-typography" i18n="@@validate.email.link.info">For your security, the invite link expires after 7 days.</p>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-icon style="font-size: 70px;height: 70px;width: 70px;">timer</mat-icon>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mat-card
  class="tc-container tc-container--small"
  style="margin-top: -40px; z-index: 1"
  *ngIf="identity?.status === 'needs_2fa_setup' && linkValid || !!backupCodes?.length"
>
  <mat-card-title
    i18n="title @@auth.2fa"
  > Setup 2FA</mat-card-title>
  <mat-card-content>
    <tc-setup-2fa></tc-setup-2fa>
  </mat-card-content>
</mat-card>
